import {
  IonContent,
  IonPage,
  IonSpinner,
  useIonAlert,
  useIonToast,
} from '@ionic/react';
import VStack from 'components/VStack';
import { useStores } from 'models';
import { RunModel, RunModelModel } from 'models/RunModel/RunModel';
import RunPage from 'pages/ViewRunPage';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router';
import { Area, useCloudStorage } from 'services/Database/CloudStorageService';
import Trans from 'util/Trans';
import { toJS } from 'mobx';
import { isInDebugMode } from '../../util';
import { MESSAGE_ALIVE_MS, MESSAGE_POSITION } from 'util/constants';

const SharedRunPage = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const params = useParams<{ id?: string }>();
  const storage = useCloudStorage();
  const { recordList } = useStores();
  const [record, setRecord] = useState<RunModel | null>(null);
  const [shared, setShared] = useState(true);
  const [alert] = useIonAlert();
  const [present] = useIonToast();

  const paramsId = params.id;

  const trickCB = useCallback(
    (cloudRecord: RunModel | null, paramsId: string) => {
      setRecord(cloudRecord);
      if (!cloudRecord) {
        present({
          message: 'Figure not available',
          duration: MESSAGE_ALIVE_MS,
          color: 'danger',
          position: MESSAGE_POSITION,
        });
      }
    },
    [setRecord, alert, history, t]
  );

  useEffect(() => {
    if (!paramsId || record?.id === paramsId) return;

    let theRun;
    if (
      (theRun = recordList.friendsRuns.find((t) => t.shareUrl === paramsId))
    ) {
      setShared(false);
      trickCB(theRun, paramsId);
      return;
    }
    storage
      .getRun(paramsId)
      .then(async (record) => {
        // retry in production if in debug mode
        if (!record && isInDebugMode()) {
          return storage.getRun(paramsId, Area.test);
        }
        return record;
      })
      .then(async (record) => {
        let newRecord: RunModel | null;
        if (record) {
          newRecord = RunModelModel.create(
            toJS(record),
            recordList.environment
          );
          await Promise.all([
            newRecord.downloadPlayData(),
            newRecord.downloadVideo(),
          ]);
        } else {
          newRecord = record;
        }
        trickCB(newRecord, paramsId);
      });
  }, [paramsId, recordList, storage, trickCB, record?.id]);

  // When directed to a shared trick we might need to download it
  // first from the backend and then show it
  if (record) {
    return <RunPage record={record} shared={shared} />;
  }
  return (
    <IonPage className="notchSafe">
      <IonContent>
        <VStack className="centering">
          <Trans i18nKey="RECEIVING_TRICK">Empfange Run</Trans> '{params.id}'
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
            }}
          >
            <IonSpinner name="crescent" style={{ width: 48, height: 48 }} />
          </div>
        </VStack>
      </IonContent>
    </IonPage>
  );
};

export default SharedRunPage;
